import { render, staticRenderFns } from "./myReports.vue?vue&type=template&id=281b1244&scoped=true&"
import script from "./myReports.vue?vue&type=script&lang=js&"
export * from "./myReports.vue?vue&type=script&lang=js&"
import style0 from "./myReports.vue?vue&type=style&index=0&id=281b1244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b1244",
  null
  
)

export default component.exports